import { render, staticRenderFns } from "./UpdateOrgCustom.vue?vue&type=template&id=4df1e67c&"
import script from "./UpdateOrgCustom.vue?vue&type=script&lang=js&"
export * from "./UpdateOrgCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UpdateOrgCustom.vue"
export default component.exports